module.exports = __webpack_public_path__ + "img/text_econsenso.4de13406.png";